import { render, staticRenderFns } from "./SocialFeedUpdate.vue?vue&type=template&id=b1baed04&"
import script from "./SocialFeedUpdate.vue?vue&type=script&lang=js&"
export * from "./SocialFeedUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports